// extracted by css-extract-rspack-plugin
export default {"filter-count":"Filters-module__filter-count--qAEeJ","filterCount":"Filters-module__filter-count--qAEeJ"};